import Axios from "axios";
import { Environment } from "./common/types";

export default class Loader {
  public static SetAppLoadingMessage(
    message: string,
    hideSpinner: boolean = false
  ) {
    const textElem = document.getElementById("appLoadingMsg");
    if (textElem !== null) {
      textElem.innerText = message;
    }

    const spinnerElem = document.getElementById("appLoadingSpinner");
    if (spinnerElem !== null) {
      spinnerElem.style.display = hideSpinner ? "none" : "block";
    }
  }

  public static async InitialiseEnvironment() {
    Loader.SetAppLoadingMessage("Loading Environment Settings ...", false);
    const res = await Axios.get("/environment.json", {
      validateStatus: s => true
    });

    if (res.status === 200) {
      const env = res.data as Environment;
      if (
        env === null ||
        (env.IdentityServerBaseUrl || "").trim() === "" ||
        (env.Prospect365MyPortalBaseUrl || "").trim() === ""
      ) {
        Loader.SetAppLoadingMessage("Invalid Environment Settings", true);
        throw new Error("Invalid Environment Settings");
      } else {
        return env;
      }
    } else {
      Loader.SetAppLoadingMessage(
        "Error Loading Environment Settings: " +
          res.status.toString() +
          " - " +
          res.statusText,
        true
      );
      throw new Error("Error Loading Environment Settings");
    }
  }
}
